import { apiCall } from "../../../../../_utils";
import { apiUrls } from "../../../../../_constants";

export const eventAttendeesService = {
  getAllEventsAttendees
};

function getAllEventsAttendees(params) {
  return apiCall("GET", apiUrls.events.attendees, null, params);
}
